import React from 'react';
import TopNavigation from '../TopNavigation';

const OntarioSpeedCamerasBlog: React.FC = () => {
  return (
    <>
      <style>{`
        .blog-page {
          font-family: 'Georgia', serif;
          background: #fafaf8;
          color: #1a1a18;
          line-height: 1.85;
          min-height: 100vh;
        }
        .blog-content {
          max-width: 740px;
          margin: 0 auto;
          padding: 3rem 1.5rem 5rem;
        }
        .blog-kicker {
          font-family: sans-serif;
          font-size: 11px;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #888;
          margin-bottom: 0.75rem;
        }
        .blog-content h1 {
          font-family: 'Georgia', serif;
          font-size: clamp(28px, 4vw, 44px);
          font-weight: 700;
          line-height: 1.2;
          margin-bottom: 1rem;
          color: #111;
        }
        .blog-meta {
          font-family: sans-serif;
          font-size: 12px;
          color: #999;
          padding-bottom: 1.5rem;
          border-bottom: 1px solid #e8e6e0;
          margin-bottom: 1.75rem;
        }
        .blog-lede {
          font-size: 19px;
          font-weight: 300;
          font-style: italic;
          line-height: 1.7;
          margin-bottom: 1.5rem;
          color: #222;
        }
        .blog-content p {
          font-size: 16px;
          font-weight: 300;
          line-height: 1.9;
          margin-bottom: 1.2rem;
          color: #1a1a18;
        }
        .blog-content h2 {
          font-family: 'Georgia', serif;
          font-size: 26px;
          font-weight: 700;
          margin: 2.75rem 0 0.9rem;
          line-height: 1.3;
          color: #111;
        }
        .blog-content h3 {
          font-family: sans-serif;
          font-size: 11px;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.09em;
          color: #999;
          margin: 2.25rem 0 0.6rem;
        }
        .blog-content hr {
          border: none;
          border-top: 1px solid #e8e6e0;
          margin: 2.25rem 0;
        }
        .blog-pq {
          border-left: 3px solid #ccc;
          padding: 0.6rem 1.5rem;
          margin: 2rem 0;
          font-family: 'Georgia', serif;
          font-size: 20px;
          font-style: italic;
          line-height: 1.55;
          color: #333;
        }
        .blog-numgrid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 12px;
          margin: 1.5rem 0;
        }
        .blog-numbox {
          background: #f5f3ee;
          border-radius: 8px;
          padding: 1rem 1.1rem;
        }
        .blog-bignum {
          font-family: 'Georgia', serif;
          font-size: 30px;
          font-weight: 700;
          line-height: 1;
          color: #111;
        }
        .blog-bignumlabel {
          font-family: sans-serif;
          font-size: 12px;
          color: #777;
          margin-top: 5px;
          line-height: 1.45;
        }
        .blog-table {
          width: 100%;
          border-collapse: collapse;
          margin: 1.5rem 0;
          font-family: sans-serif;
          font-size: 13px;
        }
        .blog-table th {
          text-align: left;
          font-weight: 500;
          color: #555;
          border-bottom: 2px solid #e8e6e0;
          padding: 8px 12px 8px 0;
        }
        .blog-table td {
          padding: 9px 12px 9px 0;
          border-bottom: 1px solid #f0ede6;
          color: #333;
          vertical-align: top;
        }
        .blog-table tr:last-child td { border-bottom: none; }
        .blog-steps { margin: 1.5rem 0; }
        .blog-step { display: flex; gap: 14px; margin-bottom: 1.1rem; align-items: flex-start; }
        .blog-stepnum {
          flex-shrink: 0;
          width: 30px; height: 30px;
          border-radius: 50%;
          background: #f0ede6;
          border: 1px solid #ddd;
          display: flex; align-items: center; justify-content: center;
          font-family: sans-serif;
          font-size: 13px; font-weight: 500;
          margin-top: 3px;
          color: #444;
        }
        .blog-steptext { font-size: 15.5px; font-weight: 300; line-height: 1.8; }
        .blog-steptext strong { font-weight: 500; }
        .blog-byline {
          font-family: sans-serif;
          font-size: 12px;
          color: #999;
          font-style: italic;
          margin-top: 2rem;
          padding-top: 1.5rem;
          border-top: 1px solid #e8e6e0;
        }
        .blog-disc {
          font-family: sans-serif;
          font-size: 11px;
          color: #aaa;
          line-height: 1.65;
          margin-top: 1.5rem;
        }
        .blog-disc strong { color: #888; }
        @media (max-width: 540px) {
          .blog-numgrid { grid-template-columns: 1fr; }
        }
      `}</style>

      <TopNavigation onLogin={() => {}} user={null} onLogout={() => {}} />

      <div className="blog-page">
        <div className="blog-content">

          <a href="/blog" style={{display:'inline-block',marginBottom:'1.5rem',fontFamily:'sans-serif',fontSize:'13px',color:'#888',textDecoration:'none'}}>← All Posts</a>

          <div className="blog-kicker">Fiscal Policy · Ontario</div>
          <h1>Ontario Takes a Speed Bump to Fiscal Policy</h1>
          <div className="blog-meta">LarrysHelp.org &nbsp;·&nbsp; December 2025 &nbsp;·&nbsp; 4 min read</div>

          <p className="blog-lede">On November 14, 2025, Ontario banned automated speed enforcement cameras province-wide and announced a $210 million fund for speed bumps instead. The stated goal: save drivers from "cash grab" tickets. The problem? The fiscal math doesn't work.</p>

          <h2>Quick Background</h2>

          <p>Ontario municipalities deployed 700+ automated speed cameras starting around 2020. Toronto alone had 75. The cameras issued $100 fines for speeding (no demerit points), typically mailed weeks after the offense.</p>

          <p>A SickKids study found speeding dropped 45% in Toronto safety zones. Over 20 mayors and the Ontario Association of Chiefs of Police requested program reforms rather than elimination. The province chose elimination.</p>

          <hr />

          <h2>The Revenue Ontario Just Walked Away From</h2>

          <p>Cameras don't catch every speeder. Factoring in positioning, hours of operation, and enforcement thresholds, a realistic capture rate is 10–20% of actual speeders.</p>

          <div className="blog-numgrid">
            <div className="blog-numbox">
              <div className="blog-bignum">700</div>
              <div className="blog-bignumlabel">Cameras operating province-wide</div>
            </div>
            <div className="blog-numbox">
              <div className="blog-bignum">$255M</div>
              <div className="blog-bignumlabel">Annual revenue at 10% capture rate</div>
            </div>
            <div className="blog-numbox">
              <div className="blog-bignum">$510M</div>
              <div className="blog-bignumlabel">Annual revenue at 20% capture rate</div>
            </div>
          </div>

          <p>Realistic annual revenue: <strong>$250–500 million</strong>. This aligns with a well-designed program — cameras ticketing at 10 km/h over (not 5), limited hours, capped tickets per vehicle. You'd naturally land in that 10–20% range.</p>

          <hr />

          <h2>The $460M–$710M Swing</h2>

          <p>Here's the full policy trade:</p>

          <table className="blog-table">
            <thead>
              <tr>
                <th>Item</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Annual revenue foregone</td>
                <td>$250–500M</td>
              </tr>
              <tr>
                <td>One-time spend on speed bumps</td>
                <td>$210M</td>
              </tr>
              <tr>
                <td><strong>Net cost to taxpayers — year one</strong></td>
                <td><strong>$460M–$710M</strong></td>
              </tr>
              <tr>
                <td>Ongoing annual cost (years 2+)</td>
                <td>$250–500M/yr</td>
              </tr>
            </tbody>
          </table>

          <div className="blog-pq">"Every year after that, Ontario forgoes $250–500M that could have funded crossing guards, police officers, or road safety improvements."</div>

          <hr />

          <h2>Police Enforcement: The Cost Comparison</h2>

          <p>The Ontario Association of Chiefs of Police supported keeping cameras, noting that automated enforcement frees officers for other priorities.</p>

          <p>A camera operates 24/7 at minimal cost per hour. A police officer costs $100K+ annually in salary and benefits. Shifting to manual enforcement means reallocating officers from other duties — it doesn't make speeding enforcement cheaper, it makes it more expensive.</p>

          <hr />

          <h2>The Fix: What a Reformed Program Looks Like</h2>

          <p>These six reforms address every legitimate concern while preserving the fiscal and safety benefits:</p>

          <div className="blog-steps">
            <div className="blog-step">
              <div className="blog-stepnum">1</div>
              <div className="blog-steptext"><strong>Higher threshold.</strong> Ticket at 60 in a 50 zone, not 55. Meaningful buffer for drivers.</div>
            </div>
            <div className="blog-step">
              <div className="blog-stepnum">2</div>
              <div className="blog-steptext"><strong>Time-of-day focus.</strong> School zone cameras only operate during school hours. No tickets at 11 PM on a Saturday.</div>
            </div>
            <div className="blog-step">
              <div className="blog-stepnum">3</div>
              <div className="blog-steptext"><strong>Cap per vehicle per month.</strong> One ticket per camera per vehicle per month. First is a warning, then you're on notice.</div>
            </div>
            <div className="blog-step">
              <div className="blog-stepnum">4</div>
              <div className="blog-steptext"><strong>Grace period.</strong> First offense = warning letter. Second offense = ticket.</div>
            </div>
            <div className="blog-step">
              <div className="blog-stepnum">5</div>
              <div className="blog-steptext"><strong>Graduated fines.</strong> $50 first ticket, $100 second, $150 third. Escalate for repeat offenders.</div>
            </div>
            <div className="blog-step">
              <div className="blog-stepnum">6</div>
              <div className="blog-steptext"><strong>Transparency.</strong> Better signage, public data on camera locations and ticket volumes.</div>
            </div>
          </div>

          <p>These reforms naturally reduce ticket volumes to the 10–20% range — only the most consistent offenders — while preserving the 45% reduction in speeding that the SickKids data showed.</p>

          <hr />

          <h2>The Bottom Line</h2>

          <table className="blog-table">
            <tbody>
              <tr>
                <td>Lost annual revenue</td>
                <td>$250–500M</td>
              </tr>
              <tr>
                <td>One-time infrastructure spend</td>
                <td>$210M</td>
              </tr>
              <tr>
                <td>Proven safety benefit eliminated</td>
                <td>45% reduction in speeding</td>
              </tr>
              <tr>
                <td>Enforcement burden shifted to</td>
                <td>Police officers</td>
              </tr>
              <tr>
                <td><strong>Total year-one fiscal swing</strong></td>
                <td><strong>$460M–$710M</strong></td>
              </tr>
            </tbody>
          </table>

          <p>That revenue could fund crossing guards, police officers, road repairs, or other municipal priorities. A reformed program could have addressed every legitimate complaint — the cash-grab perception, the lack of warnings, the late notices — while keeping both the safety and fiscal benefits.</p>

          <div className="blog-byline">
            Written by the team at LarrysHelp.org.
          </div>

          <div className="blog-disc">
            <strong>Disclaimer:</strong> Revenue estimates based on 700 cameras, 100 tickets/camera/day, $100/ticket average, at 10–20% capture rates. All figures illustrative. Educational analysis only — not financial or legal advice.
          </div>

        </div>
      </div>
    </>
  );
};

export default OntarioSpeedCamerasBlog;
